module.exports = __webpack_public_path__ + "h5/img/noshop.f3396043.png";